module.exports = __webpack_public_path__ + "static/media/navDropIcon.f4121938.svg";